import React, { useEffect, useState } from 'react';
import api from '../../../../Services/api';
import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Link, useNavigate } from "react-router-dom";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import EstablishmentDetails from './EstablishmentDetails';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import MonthlyReport from '../../../../Component/Client/ClientMonthlyReport';
import ExcelSheet from './EstablishmentMonthlyCompliance'
ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    ChartDataLabels
);

const months = [
    { name: "JANUARY", value: "01" },
    { name: "FEBRUARY", value: "02" },
    { name: "MARCH", value: "03" },
    { name: "APRIL", value: "04" },
    { name: "MAY", value: "05" },
    { name: "JUNE", value: "06" },
    { name: "JULY", value: "07" },
    { name: "AUGUST", value: "08" },
    { name: "SEPTEMBER", value: "09" },
    { name: "OCTOBER", value: "10" },
    { name: "NOVEMBER", value: "11" },
    { name: "DECEMBER", value: "12" }
];
const EstablishmentMonthlyAvrg = ({divisionFilter}) => {
    const currentYear = new Date().getFullYear();

    const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);

    let data1 = sessionStorage.getItem('user');
    let corporateData = JSON.parse(data1);
    let id = corporateData.id;
    const [selectedClientForReport, setSelectedClientForReport] = useState('');
    const [isClientSelectedForReport, setIsclientSelectedForReport] = useState(false)

    const [yearlyData, setYearlyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dataNotFound, setDataNotFound] = useState(false)
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedQuarter, setSelectedQuarter] = useState('Yearly'); // New state for selected quarter/half
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
    const [data, setData] = useState({ NoOfEmployees: 0, NoOfVendors: 0 })
    const [openDialog, setOpenDialog] = useState(false);
 const[division,setDivision] = useState('')
    const [selectedClientForAudit, setSelectedClientForAudit] = useState('')
    const [selectedMonthForAudit, setSelectedMonthForAudit] = useState('');
    const [selectedYearForAudit, setSelecYearForAudit] = useState('');
    const [selectedMonthForAuditOne, setSelectedMonthForAuditOne] = useState('');
    const [selectedYearForAuditOne, setSelectedYearForAuditOne] = useState('');
    const [openDialogComplianceReport, setOpenDialogComplianceReport] = useState(false);
    const [openDialogComplianceReportOne, setOpenDialogComplianceReportOne] = useState(false);
    const [openDialogForAudit, setOpenDialogForAudit] = useState(false);
    const [openDialogForAuditOne, setOpenDialogForAuditOne] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const[divisionForReport,setDivisionForReport] = useState([])
     const [selectedDivisionForReport, setSelectedDivisionForReport] = useState("NoDivision");
    const[divisionForReportOne,setDivisionForReportOne] = useState([])
     const [selectedDivisionForReportOne, setSelectedDivisionForReportOne] = useState("NoDivision");

    const handleShow = () => {
        if (selectedMonthForAudit && selectedYearForAudit && selectedClientForAudit) {
            setOpenDialogForAudit(false);
            setTimeout(() => {
                setShowModal(true);
            }, 300);
        } else {
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage('Please select required fields to view report')
        }
    };
  const handleOpenDialogComplianceReportOne = () => {
        setOpenDialogComplianceReportOne(true);
        setOpenDialogForAuditOne(true)
        getDivisionForReportOne()
       
    };
            const getDivisionForReportOne = async () => {
          try{
              const response = await api.Corporate.getDivison(id);
              if(response.status === 200){
              setDivisionForReportOne(response.data.data);
              
              }
              else {
                  setDivisionForReportOne([])
                 


              }
          }catch(error){
              console.error('Error fetching data', error  );
          }
        
      }


            const getDivision = async () => {
          try{
              const response = await api.Corporate.getDivison(id);
              if(response.status === 200){
              setDivisionForReport(response.data.data);
              
              }
              else {
                  setDivisionForReport([])
                 


              }
          }catch(error){
              console.error('Error fetching data', error  );
          }
        
      }
        
      
    
  
    const handleDivisionChangeForReportOne = (event) =>{
const division = event.target.value
setSelectedDivisionForReportOne(division)
} 

const handleDivisionChangeForReport = (event) =>{
const division = event.target.value
setSelectedDivisionForReport(division)
}

    const handleClose = () => {
        setShowModal(false);
        setSelectedMonthForAudit('');
        setSelecYearForAudit('');
        setOpenDialogForAudit(false);

        document.body.style.overflow = 'auto';

    };




    useEffect(() => {
        fetchClients(selectedClient);
    }, [selectedClient]);


    const handleYearChangeForAudit = (event) => {
        setSelecYearForAudit(event.target.value);
    };


    useEffect(() => {
        const empcount = async () => {
            try {
                const response = await api.Corporate.employeesandVendorCount(id);
                setData({ NoOfEmployees: response.data.NoOfEmployees, NoOfVendors: response.data.NoOfVendors });
            } catch (error) {
                console.error('Error fetching data', error);
            }
        }
        empcount();
    }, [id])


    const handleOpenDialogComplianceReport = () => {
        setOpenDialogComplianceReport(true);
        setOpenDialogForAudit(true)
        getDivision()
        
         
    };
  

 

    useEffect(() => {
        
        const timer = setTimeout(() => {
            getData()
        }, 1000);

        return () => clearTimeout(timer);
    }, [selectedClient, selectedYear,divisionFilter]);


    const getData = async () => {
        try {
            if(divisionFilter === '' || divisionFilter === 'NoDivision'){
            const response = await api.Corporate.establishmentMonthlyAvrg(id, selectedYear);
            if (response.status === 200) {
                setDataNotFound(false)
                setYearlyData(response.data.data);
                setLoading(false)
            }
            else if (response.status === 400) {
                setDataNotFound(true)
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message)
                setYearlyData(null);
                setLoading(false)

            }
            else if (response.status === 404) {
                setDataNotFound(true)
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message)
                setYearlyData(null);
                setLoading(false)
            }
            else if (response.status === 500) {
                setDataNotFound(true)
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message)
                setYearlyData(null);
                setLoading(false)
            }
        }
          else{
            const response = await api.Corporate.establishmentMonthlyAvrg(id, selectedYear,divisionFilter);
            if (response.status === 200) {
                setDataNotFound(false)
                setYearlyData(response.data.data);
                setLoading(false)
            }
            else if (response.status === 400) {
            
                setDataNotFound(true)
                setErrorSnackbarOpen(true)
                
                setSnackbarErrorMessage(response.data.message)
                setYearlyData(null);
                setLoading(false)

            }
            else if (response.status === 404) {
                setTimeout(()=>{
                setDataNotFound(true)
                setErrorSnackbarOpen(true)
                },2000)
                setSnackbarErrorMessage(response.data.message)
                setYearlyData(null);
                setLoading(false)
            }
            else if (response.status === 500) {
                setDataNotFound(true)
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message)
                setYearlyData(null);
                setLoading(false)
            }
        }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedClientForReport('');
        setIsclientSelectedForReport(false);

    };

    const fetchClients = async () => {
        try {
            const response = await api.Corporate.getClientByCorporateId(id);

            if (response.status === 200) {
                setClients(response.data.data || []);
            }
            else if (response.status === 404) {
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                setClients([])
            }
            else if (response.status === 400) {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message)
                setClients([])
            }
            else {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage("Unable to fetch details, please try again")
                setClients([])
            }
        }
        catch (error) {
            console.error("Error in fetching the data", error)
        }
    }
    useEffect(() => {
        if (clients.length > 0 && !selectedClient) {
            const firstClientId = clients[0].companyId;
            setSelectedClient(firstClientId);
        }
    }, [clients, selectedClient]);



    // Data for Doughnut Chart

    const overallAccepted = yearlyData ? parseFloat(yearlyData.overallYearlyAcceptedAvg) : 0;
    const overallRejected = yearlyData ? parseFloat(yearlyData.overallYearlyRejectedAvg) : 0;
    const overallUnderReview = yearlyData ? parseFloat(yearlyData.overallyearlyUnderReviewAvg) : 0;
    const total = overallAccepted + overallRejected + overallUnderReview;

    if (total >= 100) {
        remainingPercentage = 0;
    } else {
        var remainingPercentage = (100 - (parseFloat(overallAccepted) + parseFloat(overallRejected) + parseFloat(overallUnderReview))).toFixed(2);

    }

    const doughnutData = {
        labels: ['Accepted', 'Rejected', 'UnderReview', 'Not Uploaded'],
        datasets: [
            {
                data: [overallAccepted, overallRejected, overallUnderReview, remainingPercentage],
                backgroundColor: ['#50c878', '#B22222', '#EFCC00', 'lightgray'],  // Green for accepted, red for rejected
                borderWidth: 0,


            },
        ],
    };
    const chunkData = (data, chunkSize) => {
        let result = [];
        for (let i = 0; i < data.length; i += chunkSize) {
            result.push(data.slice(i, i + chunkSize));
        }
        return result;
    };

    // Data for Bar Chart
    let clientLabels = [];
    let combinedData = [];

    if (yearlyData && yearlyData.EstablishmentAverages) {
        for (let i = 0; i < yearlyData.EstablishmentAverages.length; i++) {
            const client = yearlyData.EstablishmentAverages[i];
            const clientName = clients.find(c => c.companyId === client.companyId)?.clientName || '';

            clientLabels.push(clientName.slice(0, 5)); // Vendor names for X-axis
            // Combine the accepted and rejected data into one (you can sum or average them)
            const combinedValue = client.yearlyAcceptedAverage + client.yearlyRejectedAverage;
            combinedData.push(combinedValue);
        }
    }
    const chunkedVendorLabels = chunkData(clientLabels, 12); // Chunk the labels
    const chunkedCombinedData = chunkData(combinedData, 10);



    const getQuarterOrHalfData = () => {
        if (yearlyData && yearlyData.EstablishmentAverages) {
            return yearlyData.EstablishmentAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1AcceptedAvg;
                    case 'Q2':
                        return client.Q2AcceptedAvg;
                    case 'Q3':
                        return client.Q3AcceptedAvg;
                    case 'Q4':
                        return client.Q4AcceptedAvg;

                    case 'Yearly':
                        return client.yearlyAcceptedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };
    const handleClientChangeForAudit = (event) => {
        const { value } = event.target;
        setSelectedClientForAudit(value);
        sessionStorage.setItem('selectedCompanyId', value)
    }


    const handleCloseDialogForAudit = () => {
        setOpenDialogForAudit(false);
        setSelectedClientForAudit('')
        sessionStorage.removeItem('selectedCompanyId')
        setSelectedMonthForAudit('')
        setSelecYearForAudit('')
        setSelectedDivisionForReport('')

    };
    const handleCloseDialogForAuditOne = () => {
        setOpenDialogForAuditOne(false);
        sessionStorage.removeItem('client')
        setSelectedMonthForAuditOne('')
        setSelectedYearForAuditOne('')
        setSelectedDivisionForReportOne('')
        

    };
    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.target.value);
    };

    const getQuarterOrHalfDataRejected = () => {
        if (yearlyData && yearlyData.EstablishmentAverages) {
            return yearlyData.EstablishmentAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1RejectedAvg;
                    case 'Q2':
                        return client.Q2RejectedAvg;
                    case 'Q3':
                        return client.Q3RejectedAvg;
                    case 'Q4':
                        return client.Q4RejectedAvg;

                    case 'Yearly':
                        return client.yearlyRejectedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };
    const handleMonthChangeForAudit = (event) => {
        setSelectedMonthForAudit(event.target.value);
    };
    const handleMonthChangeForAuditOne = (event) => {
        setSelectedMonthForAuditOne(event.target.value);
    };
    const handleYearChangeForAuditOne = (event) => {
        setSelectedYearForAuditOne(event.target.value);
    };
    const getQuarterOrHalfDataUnderReview = () => {
        if (yearlyData && yearlyData.EstablishmentAverages) {
            return yearlyData.EstablishmentAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1UnderReviewAvg;
                    case 'Q2':
                        return client.Q2UnderReviewAvg;
                    case 'Q3':
                        return client.Q3UnderReviewAvg;
                    case 'Q4':
                        return client.Q4UnderReviewAvg;

                    case 'Yearly':
                        return client.YearlyUnderReviewAvg;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };

    const acceptedQuarterData = getQuarterOrHalfData();
    const rejectedQuarterData = getQuarterOrHalfDataRejected();
    const underReviewQuarterData = getQuarterOrHalfDataUnderReview();

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                severity="success"
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                sx={{ marginTop: '2.9%', marginRight: '7%' }}
            >
                <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                severity="error"
                open={errorSnackbarOpen}
                autoHideDuration={2000}
                sx={{ marginTop: '2.9%', marginRight: '7%' }}
                onClose={() => setErrorSnackbarOpen(false)}
            >
                <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
            </Snackbar>

            <div>
                {loading ? (
                    <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
                        <h3>Loading</h3>
                        <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
                        <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
                        <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>

                    </div>
                ) : (



                    <section className='mt-3 d-flex flex-row w-100 justify-content-between gap-2'>
                        <div className='w-100'>
                            {yearlyData && yearlyData.EstablishmentAverages ? (

                                <section className="d-flex flex-column" style={{ border: '1px solid lightgray' }}>



                                    <div className='text-light bg-dark p-3'>
                                        <h1 className='text-center'>Establishment MonthlyData</h1>
                                    </div>

                                    <div className='d-flex'>
                                        {/* Dognut section */}
                                        <div>
                                            <div className="d-flex justify-content-between p-3" >
                                                <h6 className="text-dark">Average Monthly Compliance</h6>
                                                <select value={selectedYear} onChange={handleYearChange} className="mx-3 year-dropdown text-dark bg-light" style={{ cursor: 'pointer', border: '1px solid lightgray' }}>
                                                    {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                            {!dataNotFound ? (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                                                    <div style={{ height: '220px', width: '220px' }}>
                                                        <Doughnut
                                                            data={doughnutData}
                                                            options={{
                                                                cutout: '30%',
                                                                backgroundColor: 'black',
                                                                responsive: true,
                                                                plugins: {
                                                                    legend: {
                                                                        display: false,

                                                                    },
                                                                    tooltip: {
                                                                        callbacks: {
                                                                            label: function (context) {
                                                                                let percentage;
                                                                                if (context.label === 'Accepted') {
                                                                                    percentage = overallAccepted;
                                                                                    return `Accepted: ${percentage}%`;
                                                                                } else if (context.label === 'Rejected') {
                                                                                    percentage = overallRejected;
                                                                                    return `Rejected: ${percentage}%`;
                                                                                } else if (context.label === 'UnderReview') {
                                                                                    percentage = overallUnderReview;
                                                                                    return `UnderReview: ${percentage}%`;
                                                                                } else if (context.label === 'Not Uploaded') {
                                                                                    percentage = remainingPercentage;
                                                                                    return `Not Uploaded: ${percentage}%`;
                                                                                }
                                                                            },
                                                                        },
                                                                    },
                                                                    datalabels: {
                                                                        display: true,
                                                                        color: 'white',
                                                                        align: 'center',
                                                                        anchor: 'center',
                                                                        font: {
                                                                            size: 13,
                                                                        },
                                                                        formatter: function (value) {
                                                                            return value === 0 ? '' : `${value}%`;
                                                                        },
                                                                        position: 'outside',
                                                                        offset: 15,
                                                                    },
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </div>) : (
                                                <p>No data found for selected year</p>
                                            )}
                                        </div>


                                        {/* Site wise section */}
                                        <div className='w-50 d-flex flex-column' style={{ borderLeft: '1px solid lightgray' }}>
                                            <div className='p-3 d-flex text-center justify-content-between'>
                                                <h6 className="text-dark">Establishment Wise Average Monthly Compliance</h6>
                                                <select
                                                    value={selectedQuarter}
                                                    onChange={handleQuarterChange}
                                                    className="quarter-dropdown text-dark bg-light mx-3"
                                                    style={{ cursor: 'pointer', border: '1px solid lightgray' }}
                                                >
                                                    {['Yearly', 'Q1', 'Q2', 'Q3', 'Q4'].map((quarter) => (
                                                        <option key={quarter} value={quarter}>
                                                            {quarter}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>



                                            {chunkedVendorLabels.map((chunk, index) => {
                                                return (
                                                    <Bar
                                                        className="w-100"
                                                        key={index}

                                                        data={{
                                                            labels: chunk, // Vendor names for the X-axis
                                                            datasets: [
                                                                {
                                                                    label: 'Accepted',
                                                                    data: acceptedQuarterData,  // Data for "Accepted"
                                                                    backgroundColor: '#3CB371', // Green color for "Accepted"
                                                                    borderColor: '#50c878',
                                                                    borderRadius: 0, // No border radius
                                                                    borderWidth: 0,
                                                                    barThickness: 25,
                                                                    stack: 'stack1'// Set bar thickness for accepted bars

                                                                },

                                                                {
                                                                    label: 'UnderReview',
                                                                    data: underReviewQuarterData,  // Data for "Accepted"
                                                                    backgroundColor: '#EFCC00', // Green color for "Accepted"
                                                                    borderColor: '#EFCC00',
                                                                    borderRadius: 0, // No border radius
                                                                    borderWidth: 0,
                                                                    barThickness: 25,
                                                                    stack: 'stack1' // Set bar thickness for accepted bars

                                                                },
                                                                {
                                                                    label: 'Rejected',
                                                                    data: rejectedQuarterData,  // Data for "Rejected"
                                                                    backgroundColor: '#B22222', // Red color for "Rejected"
                                                                    borderColor: '#B22222',
                                                                    borderRadius: 0, // No border radius
                                                                    borderWidth: 0,
                                                                    barThickness: 25,
                                                                    stack: 'stack1' // Set bar thickness for rejected bars

                                                                },
                                                            ],
                                                        }}
                                                        options={{
                                                            responsive: true,
                                                            scales: {
                                                                x: {
                                                                    grid: {
                                                                        display: false, // Hide grid lines for X-axis
                                                                    },
                                                                    ticks: {
                                                                        display: true,
                                                                        color: 'gray',
                                                                        font: {
                                                                            size: 10,
                                                                        },
                                                                        maxRotation: 45,
                                                                        minRotation: 30,
                                                                    },
                                                                },
                                                                y: {
                                                                    min: 0, // Start the Y-axis from 0%
                                                                    grid: {
                                                                        display: false, // Show grid lines for Y-axis
                                                                    },
                                                                    ticks: {
                                                                        display: false, // Show ticks on Y-axis
                                                                        stepSize: 10, // Control the step size for ticks
                                                                        callback: function (value) {
                                                                            return value + '%'; // Format Y-axis ticks as percentage
                                                                        },
                                                                    },
                                                                    stacked: true,
                                                                },
                                                            },
                                                            plugins: {
                                                                legend: {
                                                                    display: false, // Disable the legend
                                                                },
                                                                title: {
                                                                    display: true,
                                                                },
                                                                tooltip: {
                                                                    callbacks: {
                                                                        label: function (tooltipItem) {
                                                                            const client = yearlyData.EstablishmentAverages[tooltipItem.dataIndex];
                                                                            const fullVendorName = clients.find(c => c.companyId === client.companyId)?.clientName || '';
                                                                            const acceptedValue = acceptedQuarterData[tooltipItem.dataIndex]; // Correct data access for Accepted
                                                                            const rejectedValue = rejectedQuarterData[tooltipItem.dataIndex]; // Correct data access for Rejected
                                                                            const underReviewValue = underReviewQuarterData[tooltipItem.dataIndex]
                                                                            if (tooltipItem.datasetIndex === 0) {
                                                                                // Dataset 0 represents Accepted
                                                                                return `${fullVendorName}: Accepted ${acceptedValue}%`;
                                                                            } else if (tooltipItem.datasetIndex === 1) {
                                                                                // Dataset 1 represents Rejected
                                                                                return `${fullVendorName}: UnderReview ${underReviewValue}%`;
                                                                            }
                                                                            else {
                                                                                return `${fullVendorName}: Rejected ${rejectedValue}%`;
                                                                            }
                                                                        }
                                                                    },
                                                                },
                                                                datalabels: {
                                                                    display: true, // Enable data labels
                                                                    color: 'white', // Text color for the percentage labels
                                                                    align: 'center', // Align the label at the center of the bar
                                                                    font: {
                                                                        size: 10, // Font size for the percentage labels
                                                                    },
                                                                    rotation: -50,
                                                                    formatter: function (value, context) {
                                                                        let roundedValue;
                                                                        if (context.datasetIndex === 0) {
                                                                            // For Accepted bars, show the accepted percentage
                                                                            const acceptedValue = acceptedQuarterData[context.dataIndex];
                                                                            roundedValue = acceptedValue;
                                                                            if (roundedValue != 0)
                                                                                return `${roundedValue}%`;
                                                                        } else if (context.datasetIndex === 2) {
                                                                            // For Rejected bars, show the rejected percentage
                                                                            const rejectedValue = rejectedQuarterData[context.dataIndex];
                                                                            roundedValue = rejectedValue;
                                                                            if (roundedValue != 0) {// Show percentage for the "Rejected" bar
                                                                                return `${roundedValue}%`
                                                                            }
                                                                        }
                                                                        else if (context.datasetIndex === 1) {
                                                                            // For Rejected bars, show the rejected percentage
                                                                            const underReviewValue = underReviewQuarterData[context.dataIndex];
                                                                            roundedValue = underReviewValue;
                                                                            if (roundedValue != 0) {// Show percentage for the "Rejected" bar
                                                                                return `${roundedValue}%`
                                                                            }
                                                                        }
                                                                        return ''; // Show percentage for the "Rejected" bar

                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                )
                                            })}

                                        </div>
                                    </div>

                                </section>
                            ) : (
                                <div className="text-center text-danger p-5">

                                    <h5 className='p-2'>No data found for selected year!!!</h5>
                                    <select value={selectedYear} onChange={handleYearChange} className="mx-3 year-dropdown text-dark bg-light border-1 border-secondary" style={{ cursor: 'pointer' }}>
                                        {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>

                                </div>


                            )

                            }
                        </div>

                        <div className="w-auto" style={{ border: '1px solid lightgray' }}>
                            <div className="p-3 bg-dark text-light">
                                <h6 className='text-center'>Reports Section</h6>
                            </div>

                            <div className="p-3">
                                {/* Report 1 */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-dark">Establishment Details</h6>
                                    <button className='text-danger' style={{ fontSize: '14px' }} onClick={handleOpenDialog}>Click Here</button>
                                </div>
                                <hr />

                                {/* Report 2 */}
                                <div className="pt-3 d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-dark">Establishment Assessment Compliance</h6>
                                    <button className='text-danger' style={{ fontSize: '14px' }} onClick={handleOpenDialogComplianceReport}>Click Here</button>
                                </div>
                                <hr />
                                <div className="pt-3 d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-dark">Establishments Monthly Compliance</h6>
                                    <button className='text-danger' style={{ fontSize: '14px' }} onClick={handleOpenDialogComplianceReportOne}>Click Here</button>
                                </div>

                            </div>
                        </div>
                    </section>
                )}
                <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                    <DialogTitle>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Export Contractor Data to Excel</span>

                            <Button onClick={handleCloseDialog} color="error">
                                Close
                            </Button>
                        </div>
                    </DialogTitle>


                    <DialogContent>
                        {clients && clients.length > 0 ? (
                            <EstablishmentDetails/>
                        ) : (
                            <><p>No Establishment found!!</p>

                            </>
                        )}
                    </DialogContent>
                </Dialog>

                <Dialog open={openDialogForAudit} onClose={handleCloseDialogForAudit} maxWidth="md" fullWidth>
                    <DialogTitle>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Assessment Report</span>
                            <Button onClick={handleCloseDialogForAudit} color="error">
                                Close
                            </Button>
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                            {/* Establishment Select */}
                            <select
                                className='text-dark'
                                value={selectedClientForAudit}
                                onChange={handleClientChangeForAudit}
                                style={{ width: '250px', height: '40px', border: '1px solid lightgray', cursor: 'pointer' }}
                            >
                                <option value="" disabled>Select Establishment</option>
                                {clients?.length > 0 && clients.map(client => (
                                    <option key={client.companyId} value={client.companyId}>
                                        {client.clientName}, {client.stateId}
                                    </option>
                                ))}
                            </select>



                            {/* Month Select */}
                            <select
                                className="p-1"
                                value={selectedMonthForAudit || ''}
                                onChange={handleMonthChangeForAudit}
                                style={{ border: '1px solid lightgray', height: '40px', cursor: 'pointer' }}
                            >
                                <option value="" disabled>Select Month</option>
                                {months.map((month) => (
                                    <option key={month.value} value={month.value}>
                                        {month.name}
                                    </option>
                                ))}
                            </select>

                            {/* Year Select */}
                            <select
                                className="p-1 text-dark"
                                value={selectedYearForAudit || ''}
                                onChange={handleYearChangeForAudit}
                                style={{ border: '1px solid lightgray', height: '40px', cursor: 'pointer' }}
                            >
                                <option value="" disabled>Select Year</option>
                                {years.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                                               {/* {divisionForReport && divisionForReport.length > 0 &&
    <select
    className='text text-dark'
        id="division"
        value={selectedDivisionForReport || ''}
        onChange={handleDivisionChangeForReport}
        style={{  border: "1px solid lightgray",height: '40px', cursor: 'pointer' }}
      >
       <option value="" disabled>
        Select Division
       </option>
        <option value="No Division">
        No Division
       </option>
        {divisionForReport.map((div, index) => (
          <option key={index} value={div}>
            {div}
          </option>
        ))}
      </select>
} */}
                            {/* Button */}
                            <button className="btn btn-sm btn-danger" onClick={handleShow}>
                                <span className="text-white">View Report</span>
                            </button>
                        </div>


                    </DialogContent>
                </Dialog>
                {showModal && (
                    <MonthlyReport
                        showModal={showModal}
                        onClose={handleClose}
                        selectedMonth={selectedMonthForAudit}
                        selectedYear={selectedYearForAudit}
                        selectedDivisionForReport={selectedDivisionForReport}
                    />
                )}


                <Dialog open={openDialogForAuditOne} onClose={handleCloseDialogForAuditOne} maxWidth="md" fullWidth>
                    <DialogTitle>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Overall Monthly Compliance Report</span>
                            <Button onClick={handleCloseDialogForAuditOne} color="error">
                                Close
                            </Button>
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                           
                            <select
                                className="p-1"
                                value={selectedMonthForAuditOne || ''}
                                onChange={handleMonthChangeForAuditOne}
                                style={{ border: '1px solid lightgray', height: '40px', cursor: 'pointer' }}
                            >
                                <option value="" disabled>Select Month</option>
                                {months.map((month) => (
                                    <option key={month.value} value={month.value}>
                                        {month.name}
                                    </option>
                                ))}
                            </select>

                            {/* Year Select */}
                            <select
                                className="p-1 text-dark"
                                value={selectedYearForAuditOne || ''}
                                onChange={handleYearChangeForAuditOne}
                                style={{ border: '1px solid lightgray', height: '40px', cursor: 'pointer' }}
                            >
                                <option value="" disabled>Select Year</option>
                                {years.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                                                                          {divisionForReportOne && divisionForReportOne.length > 0 &&
    <select
    className='text text-dark'
        id="division"
        value={selectedDivisionForReportOne || ''}
        onChange={handleDivisionChangeForReportOne}
        style={{  border: "1px solid lightgray",height: '40px', cursor: 'pointer' }}
      >
       <option value="" disabled>
        Select Division
       </option>
        <option value="NoDivision">
        Overall
       </option>
        {divisionForReportOne.map((div, index) => (
          <option key={index} value={div}>
            {div}
          </option>
        ))}
      </select>
}
                        </div>
                        {selectedMonthForAuditOne && selectedYearForAuditOne && (
                            <ExcelSheet

                                month={selectedMonthForAuditOne}
                                year={selectedYearForAuditOne}
                                division={selectedDivisionForReportOne}
                            />
                        )}
                    </DialogContent>
                </Dialog>


            </div>
        </>
    );
};

export default EstablishmentMonthlyAvrg
